import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { websocketPort } from "../../server/websocketPort";
import Theme from '../../styles/Theme/Theme';
import Spinner from "../Global/Atomics/Spinner";
import { Text } from "../Global/Atomics/Text";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import SemiCircle from "../Global/Charts/semiCircle";
import CustomIcon from "../Global/Icons/CustomIcon";

const socket = io(websocketPort);

export const ServiceStatusWidget = () => {
    const { data: operationStatusData, refetch } = useFetch(
        '/videowall/operations/status',
        'getServiceStatusWidget',
        { tenant: 'TOP/CASCAIS/CM CASCAIS' },
        60000,
        query.middlewareCommandURL
    );

    const [availability, setAvailability] = useState(null);
    const [quality, setQuality] = useState(null);

    useEffect(() => {
        if (operationStatusData && Array.isArray(operationStatusData) && operationStatusData.length > 0) {
            const avail = operationStatusData.map(s => parseFloat(s.availability)).filter(v => !isNaN(v));
            setAvailability(avail.length > 0 ? Math.round(avail.reduce((a, b) => a + b, 0) / avail.length) : 0);

            const good = operationStatusData.filter(s => (s.current?.state ?? s.state) === 2).length;
            setQuality(Math.round((good / operationStatusData.length) * 100));
        } else {
            setAvailability(95);
            setQuality(70);
        }
    }, [operationStatusData]);

    useEffect(() => {
        socket.on("manageIncident", () => refetch());
        return () => socket.off("manageIncident");
    }, [refetch]);

    return (
        <WidgetCard
            display="flex"
            flexDirection="column"
            padding={Theme.spacing.videowall.xs}
            margin={Theme.spacing.videowall.xxs}
            style={{ overflow: 'hidden' }}>

            {/* Header */}
            <div style={{ display: "flex", alignItems: 'center', marginBottom: Theme.spacing.videowall.xxs, flexShrink: 0 }}>
                <CustomIcon icon={"Gear"} color={Theme.color['teal-4']} iconSize='sm' />
                <Text color={Theme.color['coolgray-12']} marginLeft={Theme.spacing.videowall.xxs} fontSize='text_sm' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap' }}>
                    Service Status
                </Text>
            </div>

            {/* Two semi-circles side by side */}
            <div style={{ display: 'flex', flex: 1, minHeight: 0, alignItems: 'center' }}>
                {/* Availability */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0 }}>
                    <Text color={Theme.color['coolgray-10']} fontSize='text_xs' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap', marginBottom: '2px' }}>
                        Availability
                    </Text>
                    {availability !== null
                        ? <SemiCircle data={availability} />
                        : <Spinner stroke="green" />
                    }
                </div>

                {/* Divider */}
                <div style={{ width: '1px', background: Theme.color['coolgray-3'], flexShrink: 0, alignSelf: 'stretch', margin: '0 4px' }} />

                {/* Quality */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0 }}>
                    <Text color={Theme.color['coolgray-10']} fontSize='text_xs' fontWeight={Theme.typography.weight.medium} style={{ whiteSpace: 'nowrap', marginBottom: '2px' }}>
                        Quality
                    </Text>
                    {quality !== null
                        ? <SemiCircle data={quality} />
                        : <Spinner stroke="green" />
                    }
                </div>
            </div>

        </WidgetCard>
    );
};
